import productsService from "@/api/productsService";
import { PRODUCTS } from "@/types/products";

let productsPromise;

async function getProducts() {
  if (!productsPromise) {
    productsPromise = productsService.getAll().catch((error) => {
      productsPromise = undefined;
      throw error;
    });
  }

  return productsPromise;
}

export async function getProductIdByCode(productCode) {
  const products = await getProducts();
  return products.find((p) => p.code === productCode)?.id ?? null;
}

export async function getImsProductId() {
  return getProductIdByCode(PRODUCTS.IMS);
}
